export interface SeoPage {
  title: string;
  eyebrow: string;
  description: string;
  sections: { title: string; text: string }[];
}
import { SEO_CHAT_PAGES } from "./seo-pages/chat-pages";
import { SEO_ALTERNATIVE_PAGES } from "./seo-pages/alternative-pages";
import { SEO_TOPIC_PAGES } from "./seo-pages/topic-pages";
import { SEO_COMMUNITY_PAGES } from "./seo-pages/community-pages";
import { SEO_SITE_PAGES } from "./seo-pages/site-pages";
import { SEO_BLOG_PAGES } from "./seo-pages/blog-pages";

export const SEO_PAGES: Readonly<Record<string, SeoPage>> = {
  ...SEO_CHAT_PAGES,
  ...SEO_ALTERNATIVE_PAGES,
  ...SEO_TOPIC_PAGES,
  ...SEO_COMMUNITY_PAGES,
  ...SEO_SITE_PAGES,
  ...SEO_BLOG_PAGES,
};
